import React from 'react';

const MapDetailsBox = (props) => {
	let visibleclass = "";
	if (props.visible) {
		visibleclass = "active";
	}
	return (
		<div className={"marker-list-box "+visibleclass}>
			<div className={"marker-list-columns"}>
				{props.markers.map((marker,index) => {
					if(marker.Location !== null) {
						return (
							<div key={index} onClick={createMarkerClickFunc(index, props.renderedMarkers)} className={"marker-list-marker"}>{marker.id}. &nbsp; {marker.Location}</div>
						)
					} else {
						return null
					}
				})}
			</div>
			<div className="marker-info-close-btn" onClick={closeClick.bind(this, props.activeCategory, props.onCategoryChange)}>X</div>
		</div>
	)
}

function createMarkerClickFunc(markerIdx, renderedMarkers) {
	return (event) => {
		window.google.maps.event.trigger(renderedMarkers[markerIdx], 'click');
	};
}

function closeClick(activeCategory, onCategoryChange) {
	onCategoryChange(activeCategory);
	[].slice.call(document.getElementsByClassName('category-switcher-cell'))
		.forEach(function(elem) {
			elem.classList.remove('active');
		});
}

export default MapDetailsBox;


/** WEBPACK FOOTER **
 ** ./src/modules/location/elements/MapDetailsBox.js
 **/